<template>
  <div class="column">
    <div>
      <button @click="$emit('back')">Back</button>
      <Datepicker style="display: inline-block;" v-model="date" :format="'d MMMM yyyy'" :inline="false"></Datepicker><button @click="searchDateInRoom">Find message on this day</button>
      <button v-show="isRoomAdminLoggedIn" @click="print()">Transcript</button>
      <button v-show="isRoomAdminLoggedIn" @click="downloadCSV()">CSV</button>
    </div>
    <div>
      <input class="searchbox" placeholder="Search Messages within this room." type="text" v-model="search" @keyup.enter="searchWordInRoom" @change="searchWordInRoom" />
    </div>
    <div v-if="results && results.length === 0">
      <h2>No results</h2>
    </div>
    <div v-if="results && results.length > 0">
      <ul>
        <li :key="rr._id" v-for="rr in results">
          Sender: {{ rr.senderName }}
          <div v-if="rr.type === 'text'">
            {{ rr.text }}
          </div>
          <div v-if="rr.type === 'img' || rr.type === 'image'">
            <img class="img" :src="rr.imgURL || getURL(rr)" alt="">
          </div>
          <div v-if="rr.type === 'poll'">
            <Poll :isRoomAdminLoggedIn="isRoomAdminLoggedIn" :roomPW="roomPW" :msg="rr" ></Poll>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import * as API from '../YoNetwork/YoNetwork'
import Poll from '../Dialogue/Poll.vue'
// import ImageMsg from '../Dialogue/ImageMsg.vue'
import Datepicker from 'vuejs-datepicker'
// import * as jsonexport from 'jsonexport/dist'

export default {
  components: {
    Poll,
    // ImageMsg,
    Datepicker
  },
  props: {
    roomPW: {},
    isRoomAdminLoggedIn: {},
    roomID: {}
  },
  data () {
    return {
      date: new Date(),
      results: false,
      search: ''
    }
  },
  methods: {
    downloadCSV () {
      if (this.results) {
        this.$parent.toCSV(this.results.map((item, index) => {
          return {
            item: index + 1,
            date: new Date(item['created_at']),
            senderName: item['senderName'],
            type: item['type'],
            message: item['text'],
            image: item['imgURL'],
            goodAsk: item['goodAsk'],
            voteCount: item['voteUpUUID'].length
          }
        }))
      }
    },
    // toCSV (info) {
    //   jsonexport(info, (err, csv) => {
    //     if (err) {
    //       return console.log(err)
    //     }
    //     console.log(csv)
    //     var blob = new Blob([csv], { type: 'application/csv' })
    //     var url = URL.createObjectURL(blob)
    //     var link = document.createElement('a')
    //     link.setAttribute('href', url)
    //     link.setAttribute('download', 'messages.csv')
    //     link.click()
    //   })
    // },
    print () {
      window.print()
    },
    getURL (msg) {
      if (msg.imgBucket && msg.imgUUID && msg.imgExt) {
        return `https://${msg.imgBucket}.s3.amazonaws.com/${msg.imgUUID}.${msg.imgExt}`
      } else {
        return msg.url
      }
    },
    async searchWordInRoom () {
      let resp = await API.findMessage({ roomID: this.roomID, text: this.search })
      this.results = resp.data.sort((a, b) => {
        if (a.isPinned) {
          return -1
        } else {
          return 0
        }
      })
      console.log(resp.data)
    },
    async searchDateInRoom () {
      let year = (new Date(this.date)).getFullYear()
      let month = (new Date(this.date)).getMonth() + 1
      let date = (new Date(this.date)).getDate()
      let resp = await API.getMessageOfDay({ roomID: this.roomID, year, month, date })
      this.results = resp.data.sort((a, b) => {
        if (a.isPinned) {
          return -1
        } else {
          return 0
        }
      })
      console.log(resp.data)
    }
  }
}
</script>

<style scoped>
.searchbox{
  width: 100%;
  font-size: 40px;
  border: none;
  border-bottom: black solid 1px;
  appearance: none;
  border-radius: 0px;
  outline: none;
}
.searchbox:focus{
  outline: none;
  border: none;
  border-bottom: black solid 1px;
}
.searchbox:active{
  outline: none;
  border: none;
  border-bottom: black solid 1px;
}

.img{
  max-width: 300px;
  max-height: 300px;
}
.column{
  width: 80%;
  margin: 0px 10%;
}
</style>
